import Tooltip from '@mui/material/Tooltip';
import { List, ListItem } from '@mui/material';
import { Link } from 'react-router-dom';

export default function InfoWithPopOver({ infoList, linkUrl, linkOpener }) {
  let createAsLink = linkOpener && linkUrl && linkUrl.length > 0;

  function getDisplayList(startIndex) {
    let listItems = [];

    for (let i = startIndex; i < infoList.length; i++) {
      listItems.push(<ListItem key={i}>{infoList[i]}</ListItem>);
    }
    return <List>{listItems}</List>;
  }

  function getMainText() {
    const text = infoList[0];
    const display = text?.length > 70 ? `${text.slice(0, 70)}...` : text;
    return <span title={text}>{display}</span>;
  }

  return (
    <>
      {infoList && infoList.length > 0 && (
        <>
          {createAsLink ? (
            <Link onClick={(e) => linkOpener(e, linkUrl)}>{getMainText()}</Link>
          ) : (
            getMainText()
          )}

          {infoList.length > 1 && (
            <Tooltip title={getDisplayList(1)}>
              <span
                sx={(theme) => ({ ml: theme.fuel6Tokens.JddcSpacingXSmall })}
                style={{
                  borderBottom: '0px',
                  textDecoration: 'underline dashed 1px'
                }}
              >
                +{infoList.length - 1} more
              </span>
            </Tooltip>
          )}
        </>
      )}
    </>
  );
}
